export enum TransactionStatus {
    won = 'Won',
    running = 'Running',
    cancelled = 'Cancelled',
    declined = 'Declined',
    lost = 'Lost',
    approved = 'Approved',
    pending = 'Pending',
}

export enum TransactionType {
    deposit,
    withdrawal,
    manual,
    other,
}

export enum CancelStatus {
    success = 'success',
    failure = 'failure',
    pending = 'pending',
    none = 'none',
}

export default interface History {
    id: string;
    title: string;
    date: Date;
    amount: number;
    status: TransactionStatus;
    cancelStatus: CancelStatus;
    isWithdrawal: boolean;
    isCancelable: boolean;
    ticketId: string;
    type: TransactionType;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/user/history/History.ts